import { safeFetch } from "../utils/safeFetch";

const BASE_URL = "/api/departments";

async function parseOrThrow(response, fallbackMessage) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || fallbackMessage || `HTTP error! status: ${response.status}`);
  }
  if (response.status === 204) return null;
  return response.json();
}

export async function getAllDepartments(token, tenant) {
  const response = await safeFetch(BASE_URL, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  return parseOrThrow(response, "Errore caricamento reparti.");
}

export async function getMyDepartmentScope(token, tenant) {
  const response = await safeFetch(`${BASE_URL}/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  return parseOrThrow(response, "Errore caricamento reparti utente.");
}

export async function createDepartment(payload, token, tenant) {
  const response = await safeFetch(BASE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });
  return parseOrThrow(response, "Errore creazione reparto.");
}

export async function updateDepartment(id, payload, token, tenant) {
  const response = await safeFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });
  return parseOrThrow(response, "Errore aggiornamento reparto.");
}

export async function deleteDepartment(id, token, tenant) {
  const response = await safeFetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  return parseOrThrow(response, "Errore eliminazione reparto.");
}

export async function updateUserDepartments(userId, departmentIds, token, tenant) {
  const response = await safeFetch(`${BASE_URL}/users/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify({ departmentIds }),
  });
  return parseOrThrow(response, "Errore aggiornamento reparti utente.");
}
